import type { ReactNode } from "react";
import className from "~/kernel/styling/className";

type SpacedContentProps = {
  size?: "small" | "medium";
  children: ReactNode;
};

export default function SpacedContent({
  size = "small",
  children,
}: SpacedContentProps) {
  return (
    <div
      className={className({
        "space-y-5": size === "small",
        "space-y-8": "medium",
      })}
    >
      {children}
    </div>
  );
}
